import { FONT_SECONDARY } from "@/theme/typography";

export const tabsStyles = {
  "& .MuiTabs-flexContainer": {
    justifyContent: { xs: "start", sm: "center" },
  },
};

export const descriptionStyles = {
  fontSize: "1rem",
  fontFamily: FONT_SECONDARY,
  fontWeight: 500,
};

export const specificationListStyles = {
  listStyleType: "disc",
  pl: 2,
  display: "flex",
  flexDirection: "column",
};

export const specificationListItemStyles = { display: "list-item" };

export const featuresContainerStyles = {
  display: "flex",
  justifyContent: "end",
  alignItems: "center",
};

export const featuresImageContainerStyles = {
  width: "100%",
  maxWidth: 343,
  boxSizing: "border-box",

  img: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
  },
};
